<template>
    <div id="index">
        <el-scrollbar :class="isCollapse?'menu_hide rightSide':'rightSide'">
            <el-main>
                <nav-bar></nav-bar>
                <el-form ref="formselect" :model="formselect" label-width="80px" class="queryform_div">
                    <areaSelect :level="level" :deviceType="deviceType" :formArea="formArea" @areaList="getAreaList"></areaSelect>
                    <el-form-item :label="$t('TimeSlot')">
                        <el-date-picker type="datetimerange"
                                        v-model="selectTime"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        :range-separator="$t('To')"
                                        :start-placeholder="$t('StartDate')"
                                        :end-placeholder="$t('EndDate')">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="getData" type="primary">{{ $t('Query') }}</el-button>
                        <el-button @click="reset">{{ $t('Reset') }}</el-button>
                    </el-form-item>
                </el-form>
                <template>
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add"
                               v-if="judge('StopElectric_Create')"
                               style="margin-bottom:10px;">{{ $t('AddPowerOutageTime') }}
                    </el-button>
                    <el-table ref="multipleTable"
                              :data="tableData1"
                              v-loading="loading"
                              border
                              stripe
                              style="width:100%;min-height:200px;">
                        <el-table-column fixed="left"
                                         type="index"
                                         :label="$t('SN')"
                                         width="50">
                        </el-table-column>
                        <el-table-column prop="deviceName"
                                         :label="$t('Meter')"
                                         width="150px">
                        </el-table-column>
                        <el-table-column prop="StartD"
                                         :label="$t('EndDate')"
                                         width="100px">
                        </el-table-column>
                        <el-table-column prop="EndD"
                                         :label="$t('EndDate')"
                                         width="100px">
                        </el-table-column>
                        <el-table-column prop="StartT"
                                         :label="$t('DailyStartTime')"
                                         width="100px">
                        </el-table-column>
                        <el-table-column prop="EndT"
                                         :label="$t('DailyEndTime')"
                                         width="100px">
                        </el-table-column>
                        <el-table-column prop="stopReason"
                                         :label="$t('PowerOutageReason')"
                                         width="100px">
                        </el-table-column>
                        <el-table-column fixed="right"
                                         :label="$t('Action')"
                                         width="150">
                            <template slot-scope="scope">
                                <el-button v-if="judge('StopElectric_Update')" @click="edit(scope.row)" type="primary" size="small">
                                  {{ $t('Edit') }}</el-button>
                                <template v-if="judge('StopElectric_Delete')">
                                    <el-popconfirm placement="top"
                                                   :confirmButtonText="$t('Delete')"
                                                   :cancelButtonText="$t('Cancel')"
                                                   @onConfirm="del(scope.row.id)"
                                                   icon="el-icon-info"
                                                   iconColor="red"
                                                   :title="$t('DeleteConfirm')">
                                        <el-button size="mini" type="danger" slot="reference"
                                                   style=" margin-left: 10px;">{{ $t('Delete') }}
                                        </el-button>
                                    </el-popconfirm>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            background
                            :page-size="10"
                            @current-change="handleCurrentChange"
                            layout="prev, pager, next"
                            :total="total">
                    </el-pagination>
                </template>

            </el-main>

        </el-scrollbar>
        <el-dialog :title="$t('AddPowerOutageTime')" :visible.sync="dialogAddPowerCut" width="70%" top="10vh">
            <el-form :inline="true" ref="PCform" :model="PCform" label-width="150px">
                <el-form-item :label="$t('City')">
                    <el-select v-model="PCform.cityId" @change="getFac('add')" :placeholder="$t('el.select.placeholder')" filterable
                               class="queryform">
                        <el-option v-for="(item,index) in area" :key="'inx1'+index" :value="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Campus')">

                    <el-select v-model="PCform.factoryId" @change="getBuild('add')" :placeholder="$t('el.select.placeholder')" filterable
                               class="queryform">
                        <el-option v-for="(item,index) in facList" :key="'inx2'+index" :value="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Building')">
                    <el-select v-model="PCform.buildingId" @change="getLab('add')" :placeholder="$t('el.select.placeholder')" filterable
                               class="queryform">
                        <el-option v-for="(item,index) in building" :key="'inx3'+index" :value="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Lab')">
                    <el-select v-model="PCform.LabId" @change="getDevide('add')" :placeholder="$t('el.select.placeholder')" filterable
                               class="queryform">
                        <el-option v-for="(item,index) in labList" :key="'inx4'+index" :value="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Meter')">
                    <el-select v-model="PCform.deviceId" :placeholder="$t('el.select.placeholder')" filterable class="queryform">
                        <el-option v-for="(item,index) in deviveList" :key="'inx5'+index" :value="item.value"
                                   :label="item.label" v-if="item.type=='ElectricMeter'"></el-option>
                    </el-select>
                </el-form-item>
                <br/>
                <el-form-item :label="$t('StartDate')">
                    <el-date-picker v-model="PCform.StartD"
                                    type="date"
                                    :picker-options="startDatepicker"
                                    @focus="clickStartTime"
                                    value-format="yyyy-MM-dd"
                                    :placeholder="$t('SelectDate')" style="width: 250px;">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('EndDate')">
                    <el-date-picker v-model="PCform.EndD"
                                    type="date"
                                    @focus="clickEndTime"
                                    :picker-options="endDatepicker"
                                    value-format="yyyy-MM-dd"
                                    :placeholder="$t('SelectDate')" style="width: 250px;">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('DailyStartTime')">
                    <el-time-picker
                            :picker-options="{
                                selectableRange: '00:00:00 - 23:59:59'
                            }"
                            @change="setEndT"
                            format="HH:mm:ss"
                            value-format="HH:mm:ss"
                            v-model="PCform.StartT"
                            style="width: 250px;">
                    </el-time-picker>
                </el-form-item>
                <el-form-item :label="$t('DailyEndTime')">
                    <el-time-picker
                            :picker-options="{
                                      selectableRange: PCform.StartT+' - 23:59:59'
                                    }"
                            format="HH:mm:ss"
                            value-format="HH:mm:ss"
                            v-model="PCform.EndT"
                            style="width: 250px;">
                    </el-time-picker>
                </el-form-item>
                <el-form-item :label="$t('PowerOutageReason')">
                    <el-input v-model="PCform.stopReason" style="width: 250px;"></el-input>
                </el-form-item>
                <el-form-item style="text-align: center;width: 100%;">
                    <el-button type="success" @click="onSubmit">{{ $t('Confirm') }}</el-button>
                    <el-button @click="dialogAddPowerCut = false">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import areaSelect from '../../components/content/maintabber/areaSelect'
    import {mapState} from 'vuex';
    import {CreateStopElectric, GetAllStopElectric, UpdateStopElectric, DeleteStopElectric} from "../../api/api"
    import {fancha, getISOtime, getLocalTime, getDeviceNameByid} from '../../utils/util';
    import {judgePermission} from '../../utils/util'
    export default {
        name: "powerCut",
        data() {
            return {
                startDatepicker: {},
                endDatepicker: {},
                dialogAddPowerCut: false,
                loading: false,
                selectTime: "",
                level: 5,
                pageSize: 10,
                formselect: {
                    DeviceName: "",
                    cityId: "",
                    factoryId: "",
                    buildingId: "",
                    LabId: "",
                    DeviceId: "",
                    startTime: "",
                    EndTime: "",
                    FilterText: "",
                },
                area: JSON.parse(sessionStorage.getItem("area")),
                formArea: {cityId: "", factoryId: "", buildingId: "", LabId: "", deviceId: ""},
                facList: [],
                building: [],
                labList: [],
                deviveList: [],
                deviceType:"ElectricMeter",
                tableData1: [],
                currentPage: 0,
                total: 0,
                PCform: {
                    id: "",
                    cityId: '',
                    factoryId: '',
                    buildingId: '',
                    LabId: '',
                    deviceId: '',
                    StartD: '',
                    EndD: '',
                    StartT: '',
                    EndT: '',
                    stopReason: '',
                },
                LabTable: [],
                websock: null,
            }
        },
        mounted() {
            this.getData()
        },
        components:{
            areaSelect,
        },
        methods: {
            clickStartTime() {
                this.startDatepicker.disabledDate = time => {
                    if (this.PCform.EndD) {
                        if (time.getTime() > new Date(this.PCform.EndD).getTime()) {
                            return true
                        }
                        // if (time.getTime() < Date.now() - 8.64e7) {
                        //     return true
                        // }
                    } else {
                        // if (time.getTime() < Date.now() - 8.64e7) {
                        //     return true
                        // }
                    }
                }
            },
            clickEndTime() {
                this.endDatepicker.disabledDate = time => {
                    if (this.PCform.StartD) {
                        return (
                            time.getTime() < new Date(this.PCform.StartD).getTime()
                        )
                    } else {
                        // return time.getTime() < Date.now()
                    }
                }
            },
            setEndT() {
                if (this.PCform.StartT > this.PCform.EndT) {
                    this.PCform.EndT = this.PCform.StartT
                }
            },
            beginDate() {
                const self = this
                return {
                    disabledDate(time) {
                        if (self.PCform.EndT) {  //如果结束时间不为空，则小于结束时间
                            return new Date(self.PCform.EndT).getTime() < time.getTime()
                        } else {
                            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
                        }
                    }
                }
            },
            judge(e){
                return judgePermission(e)
            },
            getAreaList(e){
                this.formselect = {...this.formselect,...e.Valueform}
            },
            reset() {
                this.selectTime = ''
                this.formArea={cityId: "", factoryId: "", buildingId: "", LabId: "", deviceId: ""}
                this.formselect = {
                    DeviceName: "",
                    cityId: "",
                    factoryId: "",
                    buildingId: "",
                    LabId: "",
                    DeviceId: "",
                    startTime: "",
                    EndTime: "",
                    FilterText: "",
                }
                this.currentPage = 0
                this.getData()
            },
            getFac(e) {
                var a = '', id = e == 'add' ? this.PCform.cityId : this.formselect.cityId
                this.area.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.facList = this.area[a].children
                this.formselect = {...this.formselect, ...{factoryId: "", buildingId: "", LabId: "", deviceId: ""}}
                this.PCform = {...this.PCform, ...{factoryId: "", buildingId: "", LabId: "", deviceId: ""}}
            },
            getBuild(e) {
                var a = '', id = e == 'add' ? this.PCform.factoryId : this.formselect.factoryId
                this.facList.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.building = this.facList[a].children
                this.formselect = {...this.formselect, ...{buildingId: "", LabId: "", deviceId: ""}}
                this.PCform = {...this.PCform, ...{buildingId: "", LabId: "", deviceId: ""}}
            },
            getLab(e) {
                var a = '', id = e == 'add' ? this.PCform.buildingId : this.formselect.buildingId
                this.building.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.labList = this.building[a].children
                this.formselect = {...this.formselect, ...{LabId: "", deviceId: ""}}
                this.PCform = {...this.PCform, ...{LabId: "", deviceId: ""}}
            },
            getDevide(e) {
                var a = '', id = e == 'add' ? this.PCform.LabId : this.formselect.LabId
                this.labList.map((item, index) => {
                    if (id == item.value) {
                        a = index
                    }
                })
                this.deviveList = this.labList[a].children
                this.formselect = {...this.formselect, ...{deviceId: ""}}
                this.PCform = {...this.PCform, ...{deviceId: ""}}
            },
            //分页
            handleCurrentChange(val) {
                this.currentPage = (val - 1) * this.pageSize
                this.getData()
            },
            add() {
                this.clickBtn = 'add'
                this.dialogAddPowerCut = true
            },
            del(e) {

                var that = this
                DeleteStopElectric(e).then(res => {
                    if (res.success) {
                        that.$message.success("delete Success")
                        that.getData()
                    } else {
                        that.$message.error("delete failed")
                    }
                })
            },
            edit(e) {
                this.clickBtn = 'edit'
                this.dialogAddPowerCut = true
                this.PCform.id = e.id
                this.PCform.stopReason = e.stopReason
                this.$set(this.PCform, 'StartT', e.StartT)
                this.$set(this.PCform, 'EndT', e.EndT)
                this.$set(this.PCform, "StartD", e.StartD.replace(/-/g, '/'))
                this.$set(this.PCform, "EndD", e.EndD.replace(/-/g, '/'))
                var data = fancha(e.deviceId)
                for (var i in data) {
                    switch (i) {
                        case "0":
                            this.PCform.cityId = this.area[data[i]].value
                            this.facList = this.area[data[i]].children
                            break;
                        case "1":
                            this.PCform.factoryId = this.facList[data[i]].value
                            this.building = this.facList[data[i]].children
                            break;
                        case "2":
                            this.PCform.buildingId = this.building[data[i]].value
                            this.labList = this.building[data[i]].children
                            break;
                        case "3":
                            this.PCform.LabId = this.labList[data[i]].value
                            this.deviveList = this.labList[data[i]].children
                            break;
                        case "4":
                            this.PCform.deviceId = this.deviveList[data[i]].value
                            break;
                    }
                }

            },
            getData() {
                this.loading = true
                var data = this.formselect, that = this
                data.currentPage = this.currentPage
                if(this.selectTime){
                    this.formselect.startTime = getISOtime(this.selectTime[0])
                    this.formselect.EndTime = getISOtime(this.selectTime[1])
                }
                GetAllStopElectric(data).then(res => {
                    if (res.success) {
                        that.tableData1 = res.result.items
                        that.tableData1.map(i => {
                            i.StartD = getLocalTime(i.startDate).substring(0, 10)
                            i.EndD = getLocalTime(i.endDate).substring(0, 10)
                            i.StartT = getLocalTime(i.endDate).substring(11)
                            i.EndT = getLocalTime(i.endDate).substring(11)
                            // i.deviceName = getDeviceNameByid(i.deviceId, that.area).label
                        })
                        that.total = res.result.totalCount
                    } else {
                        that.$message.error("get failed")
                    }
                    that.loading=false
                })
            },
            onSubmit() {
                var startDate = `${this.PCform.StartD} ${this.PCform.StartT}`
                var endDate = `${this.PCform.EndD} ${this.PCform.EndT}`
                var data = {
                    id: this.PCform.id,
                    startDate: getISOtime(startDate),
                    endDate: getISOtime(endDate),
                    deviceId: this.PCform.deviceId,
                    stopReason: this.PCform.stopReason,
                }, that = this
                if (this.clickBtn == 'add') {
                    delete data.id
                    CreateStopElectric(data).then(res => {
                        if (res.success) {
                            that.$message.success("create success")
                            that.dialogAddPowerCut = false
                            that.getData()
                        } else {
                            that.$message.error("create failed")
                        }
                    })
                } else {
                    UpdateStopElectric(data).then(res => {
                        if (res.success) {
                            that.$message.success("update success")
                            that.dialogAddPowerCut = false
                            that.getData()
                        } else {
                            that.$message.error("update failed")
                        }
                    })
                }
            },

        },
        computed: mapState({
            isCollapse: state => state.isCollapse
        }),
    }
</script>

<style scoped>

</style>
